interface Map {
  [index: string]: string;
}

const nameToCode: Map = {
  pending: "n",
  in_progress: "i",
  passed: "p",
  failed: "f"
};

export default class TestCaseStatus {
  value: string[];

  constructor(statuses: string[], { short = false } = {}) {
    if (short) {
      let statusFlags: Map = {
        n: "",
        i: "",
        p: "",
        f: ""
      };
      statuses.forEach((status: string) => {
        const code = nameToCode[status];
        statusFlags[code] = code;
      });
      this.value = Object.values(statusFlags).filter(n => n);
    } else {
      this.value = statuses.map((status: any) => nameToCode[status]);
    }
  }
}
